import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./rootReducer";
import { APPLYING_BIOMETRIC } from "application/utils/constants";

const initialState = {
  applyBiometric: APPLYING_BIOMETRIC,
};

export const applyBiometricReducer = createSlice({
  name: "ApplyBiometricReducer",
  initialState,
  reducers: {
    setApplyBiometric: (state, action: PayloadAction<boolean>) => {
      state.applyBiometric = action.payload;
    },
    resetApplyBiometric: (state) => {
      state.applyBiometric = APPLYING_BIOMETRIC;
    },
  },
});

export const { setApplyBiometric, resetApplyBiometric } = applyBiometricReducer.actions;

export const getApplyBiometric = (state: RootState) =>
  state.applyBiometricReducer.applyBiometric;

export default applyBiometricReducer.reducer;